export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        categories: action.categories,
      };
    case 'ADD':
      return {
        ...state,
        categories: [...state.categories, action.category].sort((a, b) => {
          const titleA = a.attributes.title;
          const titleB = b.attributes.title;
          if (titleA < titleB) {
            return -1;
          }
          if (titleA > titleB) {
            return 1;
          }
          return 0;
        }),
      };
    case 'UPDATE':
      return {
        ...state,
        categories: state.categories
          .map((item) => (item.id === action.category.id ? action.category : item))
          .sort((a, b) => {
            const titleA = a.attributes.title;
            const titleB = b.attributes.title;
            if (titleA < titleB) {
              return -1;
            }
            if (titleA > titleB) {
              return 1;
            }
            return 0;
          }),
      };
    case 'DELETE':
      return {
        ...state,
        categories: state.categories
          .filter((item) => (item.id !== action.categoryId)),
      };
    default:
      throw new Error();
  }
}
